import * as React from 'react';
export const IcRemoteUniversalA = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.6 16h.8l-.4-1.08-.4 1.08zm4.52-13.12A3 3 0 0014 2h-4a3 3 0 00-3 3v14a3 3 0 003 3h4a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41.94.94 0 01-.36-.45A1 1 0 019 4.8zm.42 5a.94.94 0 01-.36-.45A1 1 0 019 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-1.39 1.41l-.02-.03zm4.26 8.2c-.06.01-.12.01-.18 0a.51.51 0 01-.47-.32l-.25-.68h-1.56l-.25.68a.503.503 0 11-.94-.36l1.5-4a.52.52 0 01.94 0l1.5 4a.518.518 0 01-.29.68zm1-8.26a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 8.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l-.03.05zm0-4a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0113 4.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27l-.03.05z'
      fill='currentColor'
    />
  </svg>
);
